export const IOS_APP_STORE_URL =
    'https://apps.apple.com/us/app/invoice-maker-generator/id1544665231';
export const GOOGLE_PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=com.invoicemaker.app';
